/* eslint-disable */
import { Component } from 'react';
import {
    API, Auth, Constant, Http, Utils, _, Trans, Images
} from 'Helpers';
import { Button, Col, Container, Row } from 'reactstrap';
import { Booster, DeadlineClock, GameweekNativeSlider, SeasonEndAlert, MyTeamRoster, InfoPopover, Banner, PitchView } from 'Components';
import { PlayerCard, TeamSubmiModal, ConfirmTransfer, FormationModal } from 'Modals';
import { StaticPage } from 'Pages';
import { ReduxHOC } from 'HOC';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { SSOLogin } from 'Components';
// import Drawer from 'react-motion-drawer';
// import GuestPitch from 'Components/GuestPitch/GuestPitch';
const {
    REACT_APP_SALARY_SUBFFIX
  } = process.env
class Hometeam extends Component {
    constructor(props) {
        super(props);
        this.nodes = {}
        this.state = {
            _temp: [],
            IS_MYTEAM: props.name == 'myteam',
            gameweeklastupdate: new Date().valueOf(),
            SelectedLeague: Utils.getMultiLeg(),
            CurrentLineup: props.root.CurrentLineup,
            AppMasterData: props.root.AppMasterData,
            sports_config: {},
            booster_list: [],

            ALL_POSITION: [],
            SORT_BY_LIST: [],
            ALL_TEAM: '',
            SALARY_CAP: null,
            team_name: '',
            is_editable: 1,
            team_info: {},
            my_performance: {},
            user_join_count: null,
            active_week: '',
            next_week: null,
            last_week: null,
            joined_week: null,
            lineup_master_id: null,


            LineupStage: '', // 'CREATE', 'EDIT',
            LineupList: Utils.getLineup() || [{ "position": "GK", "position_clone": "GK", "position_label": "GK", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "GK", "position_clone": "GK", "position_label": "GK", "is_bench_player": 1, "bench_order": 1, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "DF", "position_clone": "DF", "position_label": "DF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "DF", "position_clone": "DF", "position_label": "DF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "DF", "position_clone": "DF", "position_label": "DF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "DF", "position_clone": "DF", "position_label": "DF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "DF", "position_clone": "DF", "position_label": "DF", "is_bench_player": 1, "bench_order": 2, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "MF", "position_clone": "MF", "position_label": "MF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "MF", "position_clone": "MF", "position_label": "MF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "MF", "position_clone": "MF", "position_label": "MF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "MF", "position_clone": "MF", "position_label": "MF", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "MF", "position_clone": "MF", "position_label": "MF", "is_bench_player": 1, "bench_order": 3, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "FW", "position_clone": "FW", "position_label": "FW", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "FW", "position_clone": "FW", "position_label": "FW", "is_bench_player": 0, "bench_order": 0, "player_role": 0, "player_uid": null, "salary": 0 }, { "position": "FW", "position_clone": "FW", "position_label": "FW", "is_bench_player": 1, "bench_order": 4, "player_role": 0, "player_uid": null, "salary": 0 }],
            LineupListClone: Utils.getLineup() || [],
            LineupLoader: true,
            scoring_weeks: [],
            SelectedWeekObj: {},

            is_single_player: Utils.isSinglePlayer(),
            updatePlayerList: new Date().valueOf(),
            updateLineupInfo: null,
            updateBooster: new Date().valueOf(),
            isTeamSubmitShow: false,
            SelectedPlayer: {},
            isPlayerCardShow: false,
            SelectedWeek: '',
            SelectedWeekData: {},
            isConfirmTransferShow: false,
            InPlayers: Utils.getTransferData().in,
            BoosterPosting: false,
            isDrawerOpen: false,
            innerWidth: null,
            innerHeight: null,
            MicroSiteWidth: 991,

            FormationModalShow: false,
            default_formation: '',
            default_formation_clone: '',
            SwapActive: false,
            SwapSource: {},
            MinVal: {},
            constant_pos: Utils.getFormationInitial(),
            PlayerRoleTemp: [],
            btnActive: false,
            AutoPickPosing: false,
            MasterRosterList: [],
            RosterArr: [],
            aniclass: false,
            team_update: [],
            showSSOLogin:false

        }
    }

    setNodeRef(provider, node) {
        if (node) {
            this.nodes[provider] = node
        }
    }

    /**
     * #1
     * @description method to get lineup master data
     */
    getLineupMasterData = (param) => {
        const { t } = this.props;
        const { SelectedLeague, is_single_player, CurrentLineup } = this.state;
        Http.post(API.GET_LINEUP_MASTER_DATA, param).then(response => {
            const { data } = response;
            // console.log(this.GetMinPosValue(data.lineup_formation.formation, data.formation_positions), 'Min-pos-value')
            this.setState({
                MinVal: data.lineup_formation ? this.GetMinPosValue(data.lineup_formation.formation, data.formation_positions) : [],
                RosterMasterData: data,
                ALL_POSITION_CLONE: data.all_position,
                ALL_POSITION: [{
                    position_display_name: t('All'),
                    max_player_per_position: null,
                    position: ""
                },
                ...(is_single_player ? data.all_position[data.next_week] : data.all_position)
                ],
                team_name: data.team_name,
                booster_list: data.booster_list,
                SORT_BY_LIST: [{
                    value: '',
                    label: t('All'),
                }, ...data.sort_by_list],
                SALARY_CAP: data.salary_cap,
                default_formation: _.cloneDeep(data.default_formation),
                default_formation_clone: _.cloneDeep(data.default_formation),
                next_week: data.next_week,
                active_week: data.active_week,
                last_week: data.last_week,
                lineup_master_id: data.lineup_master_id,
                LineupStage: (data.lineup_master_id && data.lineup_master_id != 0 ? Constant.LINEUP_STAGE_EDIT : Constant.LINEUP_STAGE_CREATE),
            }, () => {

                if (is_single_player) { }

                if (Auth.getAuth()) {
                    this.getUserTeamInfo({
                        ...param,
                        lineup_master_id: CurrentLineup.team_info.lineup_master_id,
                        contest_id: CurrentLineup.contest_id
                    })
                    this.getManageTeamMaster(param)
                    Utils.setDefaultFormation(_.cloneDeep(data.default_formation))
                } else {
                    Utils.setDefaultFormation(_.cloneDeep(data.default_formation))
                    this.nodes.PitchView.lineupGenerate()
                    // Create team method
                }
            });


        }).catch(error => {
            this.props.history.push(Constant.DASHBOARD_PATH)
            console.error(error)
        });
    }

    /**
     * #2
     * @description method to get team master data
     */
    getManageTeamMaster = (option) => {
        const { CurrentLineup, is_single_player } = this.state;
        const {
            next_week_start_time,
            week_info,
            team_info,
            contest_id,
            user_join_count
        } = CurrentLineup

        this.setState({
            contest_id: contest_id,
            user_join_count: user_join_count,
            default_formation: team_info.selected_formation,
            default_formation_clone: team_info.selected_formation,
            my_performance: data.my_performance,
        }, () => {
            if (!is_single_player) {
                this.getAllTeam(option)
            }

            if (false) // Already Lineup submit
            {

            } else {
                if (user_join_count == 1) {
                    this.getUserLineupDetails({
                        ...option,
                        contest_id: contest_id,
                        lineup_master_id: team_info.lineup_master_id,
                        week: this.state.SelectedWeek == '' || _.isUndefined(this.state.SelectedWeek) ? week_info.next_week : this.state.SelectedWeek,
                    })
                } else {
                    this.getUserLineupDetails({
                        ...option,
                        contest_id: contest_id,
                        lineup_master_id: team_info.lineup_master_id,
                        week: this.state.SelectedWeek == '' || _.isUndefined(this.state.SelectedWeek) ? week_info.next_week : this.state.SelectedWeek,
                    })
                    this.setState({
                        SelectedWeek: week_info.next_week
                    }, () => {
                        this.nodes.GuestPitch.lineupGenerate('create')
                    })
                }
            }
        })
    }

    /**
     * #3
     * @description method to get user lineup details
     */
    getUserLineupDetails = (options) => {
        Http.post(API.GET_USER_LINEUP_DETAIL, options).then(response => {
            const { data } = response;
            const _lineup = _.orderBy(
                data.lineup,
                function (o) {
                    return new Number(o.rank);
                },
                ['asc']
            )

            this.setState({
                LineupList: _.cloneDeep(_lineup),
                LineupListClone: _.cloneDeep(_lineup),
                default_formation: data.formation,
                default_formation_clone: data.formation,
            }, () => {
                Utils.setDefaultFormation(_.cloneDeep(data.formation))
                this.setState({
                    updateLineupInfo: new Date().valueOf(),
                });
                // this.getUserTeamInfo(options)


                const { SelectedWeek, LineupList } = this.state
                if (LineupList.length < Number(this.getLineupRosterLimit(SelectedWeek))) {
                    this.nodes.GuestPitch.lineupGenerate('', Number(this.getLineupRosterLimit(SelectedWeek)) - LineupList.length)
                } else {
                    this.nodes.GuestPitch.lineupGenerate()
                }


            })
        }).catch(error => {
            console.error(error)
        });

    }

    /**
     * #4
     * @description method to get user team info
     */
    getUserTeamInfo = (options) => {
        const { CurrentLineup, is_single_player, SelectedWeek, next_week } = this.state;
        const {
            contest_id,
            user_join_count,
            team_info,
            week_info
        } = CurrentLineup

        this.setState({
            contest_id: contest_id,
            user_join_count: user_join_count,
            next_week: week_info.next_week,
            lineup_master_id: team_info.lineup_master_id,
            my_performance: data.my_performance,
        }, () => {
            if (!is_single_player) {
                this.getAllTeam(options)
            }
            if (false) { } else {
                if (user_join_count == 1) {
                    this.getUserLineupDetails({
                        ...options,
                        contest_id: contest_id,
                        lineup_master_id: team_info.lineup_master_id,
                        week: SelectedWeek == '' || _.isUndefined(SelectedWeek) ? next_week : SelectedWeek,
                    })
                } else {
                    this.setState({
                        SelectedWeek: next_week
                    }, () => {
                        this.nodes.GuestPitch.lineupGenerate('create')
                    })
                }
            }
        })
        Http.post(API.GET_USER_TEAM_INFO, {
            ...options,
        }).then(response => {
            const { team_info } = response.data;
            this.setState({
                team_info: team_info,
                joined_week: team_info.joined_week,
                next_week: team_info.next_week,
                active_week: team_info.active_week,
                last_week: team_info.last_week,
                lineup_master_id: team_info.lineup_master_id,
                LineupStage: (team_info.lineup_master_id && team_info.lineup_master_id != 0 ? Constant.LINEUP_STAGE_EDIT : Constant.LINEUP_STAGE_CREATE),
                boosterApplied: team_info.booster_applied,
                is_editable: team_info.is_editable,
                show_transfer: team_info.show_transfer,
                updateBooster: new Date().valueOf(),
                next_week_start_time: team_info.next_week_start_time,
            }, () => {
                if (team_info.scoring_weeks.length > 0) {
                    const { next_week } = this.state
                    let tmpSelectedWeek = {}
                    const scoring_weeks_mod = _.map(team_info.scoring_weeks, (week) => {
                        if (this.state.SelectedWeek == '' && next_week == week.week) {
                            tmpSelectedWeek = week;
                        } else if (week.week == this.state.SelectedWeek) {
                            tmpSelectedWeek = week;
                        }
                        return { ...week, id: week.week }
                    })
                    this.setState({
                        scoring_weeks: scoring_weeks_mod,
                        SelectedWeekObj: tmpSelectedWeek,
                        SelectedWeek: tmpSelectedWeek.week,
                        SelectedWeekData: tmpSelectedWeek,
                        BoosterPosting: false,
                        updateBooster: new Date().valueOf(),
                        gameweeklastupdate: new Date().valueOf()
                    })
                }
            })

        }).catch(error => {
            console.error(error)
        });

    }

    /**
     * #A
     * @description method to get All team data
     */
    getAllTeam = () => {
        const param = {
            "league_id": Utils.getMultiLeg().league_id,
            "sports_id": Utils.getMultiLeg().sports_id
        }
        const { t } = this.props;
        let s3_param = [
            API.S3_GET_ALL_TEAM,
            param.league_id
        ]
        Http.s3(Utils.s3UrlConvert(s3_param), API.GET_ALL_TEAM, param).then((response) => {
            // Http.post(API.GET_ALL_TEAM, param).then(response => {
            const { data } = response;
            // console.log('object')
            let TempViews = [{
                // max_player_per_position: null,
            }]
            _.map(data, (it) => {
                TempViews.push({ value: it.team_id, team_name: it.team_name, team_abbr: it.team_abbr })
                // console.log(TempViews)
            })
            const idx = TempViews.map(o => o.team_id)
            const filters = TempViews.filter(({ value }, index) => !idx.includes(value, index + 1))
            this.setState({
                updatePlayerList: new Date().valueOf(),
                team_update: filters,
                ALL_TEAM: [{
                    team_id: '',
                    team_abbr: t('All'),
                    team_name: t('All'),
                }, ...data],
            })

        }).catch(error => {
            console.error(error)
        });
    }
    /**
     * @description General method to data modification
     */
    getLineupRosterLimit = (week) => {
      //return ''
        const { sports_config } = this.state;
        let limit = '-'
        if (typeof sports_config.lineup_roster_limit === 'object' && sports_config.lineup_roster_limit !== null) {
            _.forEach(sports_config.lineup_roster_limit, (object, i) => {
                if (week == i) {
                    limit = object
                }
            })
        } else {
            limit = sports_config.lineup_roster_limit
        }
        return limit
    }
    RemovePlayer = ()=>{
        this.setState({
            showSSOLogin:true
        })
    }
    updateLineupList = (LineupList, isOnlyView) => {
      //  return ''
        this.setState({
            LineupList: _.cloneDeep(LineupList),
            LineupListClone: _.cloneDeep(LineupList),
            LineupLoader: false,
            InPlayers: Utils.getTransferData().in
        }, () => {
            if (isOnlyView) return;
            Utils.setLineup(LineupList)
        })
    }
    triggerPlayerList = (position) => {
        this.setState({
            showSSOLogin:true
        })
        // const {
        //     innerWidth,
        //     MicroSiteWidth
        // } = this.state;
        // if (MicroSiteWidth >= innerWidth) {
        //     this.toggleDrawer()
        //     this.nodes.PlayerListDrawer.rosterFilterUpdate(position);
        // }
        // this.nodes.PlayerList.rosterFilterUpdate(position);
    }
    GetRosterByPosition = () => {
        this.setState({
            posting: true
        });

        const { league_id, sports_id, sports_config } = this.state.SelectedLeague;;

        let param = {
            "league_id": league_id,
            "sports_id": sports_id,
            "sort_field": '',
            "in_position_group": 1,
        };

        Http.post(API.GET_ALL_ROSTER, param).then(response => {
            const { data } = response;
            this.setState({
                RosterArr: data.result,
            }, () => {
                this.setState({
                    posting: false
                })
            })
        }).catch(error => {
            this.setState({
                posting: false
            })
        });
    }
    fullLineup = () => {
        const {
            LineupList,
            next_week
        } = this.state;
        return LineupList && (LineupList.length == this.getLineupRosterLimit(next_week))
    }

    LineupSave = (is_reg = true) => {
        if (is_reg && !Utils.isCapAvailable(this.state.LineupList)) {
            Utils.notify('Please select captain', 'error')
            return
        }
        const { lineup_master_id } = this.state
        if (_.isUndefined(lineup_master_id)) {
            this.setState({ isTeamSubmitShow: true })
        } else {
            this.setState({ isTeamSubmitShow: true })


        }
    //    this.setState({showSSOLogin:true})
    }
    TeamSubmitToggle = () => {
        this.setState({
            isTeamSubmitShow: !this.state.isTeamSubmitShow
        })
    }

    ResetLineup = () => {
        const { LineupStage, LineupListClone, default_formation_clone } = this.state
        if (LineupStage == Constant.LINEUP_STAGE_EDIT) {
            this.setState({
                SwapActive: false,
                LineupList: _.cloneDeep(LineupListClone),
                LineupLoader: true,
                default_formation: _.cloneDeep(default_formation_clone)
            }, () => {
                this.setState({
                    LineupListClone: _.cloneDeep(this.state.LineupList),
                    default_formation_clone: _.cloneDeep(this.state.default_formation),
                }, () => {
                    const { SelectedWeek, LineupList } = this.state
                    this.nodes.PitchView.lineupGenerate('', Number(this.getLineupRosterLimit(SelectedWeek)) - LineupList.length)
                })
            })
        } else {
            const { SelectedWeek, LineupList, RosterMasterData } = this.state;
            this.setState({
                default_formation: Utils.getDefaultFormation() || RosterMasterData.default_formation
            }, this.nodes.PitchView.lineupGenerate('reset', Number(this.getLineupRosterLimit(SelectedWeek)) - LineupList.length))
        }

    }
    /* 
      SWAP PLAYER 
    */

    GetMinPosValue = (formation, formation_positions) => {
        let _arr = formation_positions.split('-')
        let _Arr = {
            [_arr[0]]: [],
            [_arr[1]]: [],
            [_arr[2]]: []
        }
        let single_pos = ''
        _.forEach(formation, (item, key) => {
            key = key.split('-')
            _Arr[_arr[0]].push(key[0])
            _Arr[_arr[1]].push(key[1])
            _Arr[_arr[2]].push(key[2])

            _.forEach(item, obj => {
                if (obj.number_of_bench_player == obj.number_of_players) {
                    single_pos = obj.position
                }
            })
        })

        Utils.setFormationInitial({
            'P0': single_pos,
            'P1': _arr[0],
            'P2': _arr[1],
            'P3': _arr[2],
        })

        return {
            [_arr[0]]: Number(_.min(_Arr[_arr[0]])),
            [_arr[1]]: Number(_.min(_Arr[_arr[1]])),
            [_arr[2]]: Number(_.min(_Arr[_arr[2]]))
        }
    }

    SwapInit = (player) => { }

    SwapExecute = (over) => { }

    FormationModalToggle = () => {
        this.setState({
            FormationModalShow: !this.state.FormationModalShow
        })
    }

    FormationChangeHandle = (default_formation) => {
        this.setState({
            default_formation,
            FormationModalShow: false,
            LineupLoader: true
        })
        Utils.setDefaultFormation(default_formation)
        const {
            RosterMasterData,
            LineupList
        } = this.state;
        const LineupClone = _.cloneDeep(LineupList)
        let CurrentFormation = RosterMasterData.lineup_formation.formation[default_formation]
        let k = 1;
        for (let i = 0; i < CurrentFormation.length; i++) {
            const element = CurrentFormation[i];
            var filterArr = LineupClone.filter(function (item) {
                return item.position == element.position && item.player_role == 0
            })
            _.map(filterArr, (item, idx) => {
                item.is_bench_player = '0';
                item.bench_order = '0';
                if (idx < element.number_of_bench_player) {
                    item.is_bench_player = '1';
                    item.bench_order = k;
                    k = k + 1
                }
                return item;
            })
        }
        setTimeout(() => {
            this.setState({
                LineupList: LineupClone,
                LineupLoader: false
            })
        }, 500)

    }
    /**
     * @description Lifecycle(s)
     */
    componentDidMount() {

        this.getAllTeam()
        window.addEventListener("resize", this.updateDimensions);
        const { league_id, sports_id, sports_config } = this.state.SelectedLeague;
        this.setState({
            sports_config
        })
        Promise.all([
            this.getLineupMasterData({ league_id, sports_id }),
        ])
        Utils.removeTransferData()
    }
    UNSAFE_componentWillMount() {
        this.updateDimensions();
    }
    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
        this.setState = () => {
            return;
        };
    }
    updateDimensions = () => {
        this.setState({ innerWidth: window.innerWidth, innerHeight: window.innerHeight });
    }
    toggleDrawer = (bool = true) => { }

    handleAutoPick = () => {
        this.GetRosterByPosition()
        const { t } = this.props;
        const { SelectedLeague, LineupList, default_formation } = this.state;
        const { league_id, sports_id } = SelectedLeague;
        const payload = {
            "sports_id": sports_id,
            "league_id": league_id,
            "lineup": Utils.SelectPlayerCount(LineupList) < 15 ? Utils.GetSelectPlayer(LineupList) : [],
            "selected_formation": default_formation
        }
        this.setState({
            AutoPickPosing: true,
            LineupLoader: true,
            _temp: []
        })
        Http.post(API.GET_AUTOFILL_LINEUP_DATA, payload).then(({ data }) => {
            const { LineupStage, RosterArr } = this.state

            // console.log(MasterRosterList,"MasterRosterListMasterRosterList");
            let Player = '';
            let Allplayers = [];
            Allplayers = _.map(data.lineup_player, (item) => {
                // console.log(RosterArr,'adaddsadd')
                Player = _.filter(RosterArr, (o) => o.player_uid == item.player_uid);
                return { ...(_.isEmpty(Player) ? {} : Player[0]), ...item }
            })

            const LineupListData = Allplayers

            //console.log(Allplayers,"Allplayers");


            if (LineupStage == Constant.LINEUP_STAGE_CREATE) {
                if (Utils.SelectPlayerCount(LineupList) == 0 || Utils.SelectPlayerCount(LineupList) == LineupList.length) {
                    //  console.log('Get all Player from API')
                    let LineupFieldPlayer = _.filter(LineupListData, o => {
                        return o.is_bench_player != 1
                    })
                    let LineupBenchPlayer = _.filter(LineupListData, o => {
                        return o.is_bench_player == 1 && o.position != 'GK'
                    })
                    let LineupGKBenchPlayer = _.filter(LineupListData, o => {
                        return o.is_bench_player == 1 && o.position == 'GK'
                    })

                    // let k = 2;
                    _.map(LineupFieldPlayer, item => {
                        item.player_role = '0'
                        item.bench_order = '0'
                        return item;
                    })
                    _.map(LineupGKBenchPlayer, item => {
                        // item.bench_order = '1';
                        item.bench_order = '0';
                        return item;
                    })
                    _.map(LineupBenchPlayer, item => {
                        item.bench_order = '0';
                        // item.bench_order = k;
                        // k = k + 1
                        return item;
                    })

                    let _LineupList = [...LineupFieldPlayer, ...LineupGKBenchPlayer, ...LineupBenchPlayer]
                    this.setState({
                        LineupList: _.cloneDeep(_LineupList),
                        LineupLoader: false
                    }, () => {
                        this.updateLineupList(this.state.LineupList)
                    })
                } else if (Utils.SelectPlayerCount(LineupList) < LineupList.length) {
                    //console.log('Get remaining Player from API')
                    // let k = 2;
                    const _lineup = _.filter(_.cloneDeep(LineupList), item => {
                        return item.player_uid != null
                    })
                    let LineupFieldPlayer = _.filter(_.cloneDeep(LineupListData), o => {
                        return o.is_bench_player != 1
                    })
                    const LineupGKBenchPlayer = _.filter(_.cloneDeep(LineupListData), item => {
                        return item.position == 'GK' && item.is_bench_player == 1
                    })
                    const LineupBenchPlayer = _.filter(_.cloneDeep(LineupListData), o => {
                        return o.is_bench_player == 1 && o.position != 'GK'
                    })

                    _.map(LineupFieldPlayer, item => {
                        item.player_role = '0'
                        item.bench_order = '0'
                        return item;
                    })

                    _.map(LineupGKBenchPlayer, item => {
                        item.bench_order = '0';
                        if (item.is_bench_player == 1) {
                            // item.bench_order = '1';
                            item.bench_order = '0';
                        }
                        return item;
                    })

                    _.map(LineupBenchPlayer, item => {
                        item.bench_order = '0';
                        // k = k + 1
                        return item;
                    })

                    this.setState({
                        LineupList: [..._lineup, ...LineupGKBenchPlayer, ...LineupBenchPlayer, ...LineupFieldPlayer],
                        LineupLoader: false,
                        AutoPickPosing: false,
                    }, () => {
                        this.updateLineupList(this.state.LineupList)
                    })


                }
            } else {
                const _CBlank = _.filter(LineupList, item => item.player_uid == null && item.player_role && item.player_role == 1)
                const _VCBlank = _.filter(LineupList, item => item.player_uid == null && item.player_role && item.player_role == 2)
                const _lineup = _.filter(LineupList, item => item.player_uid != null)
                const PlayerPLaceholder = _.filter(LineupList, item => item.player_uid == null)
                _.forEach(_.cloneDeep(LineupListData), (obj) => {
                    _.forEach(_.cloneDeep(PlayerPLaceholder), (item) => {
                        if (!Utils.IsPlayerExist(obj, this.state._temp) && (item.position == obj.position && item.is_bench_player == obj.is_bench_player)) {
                            this.setState({ _temp: [...this.state._temp, { ...item, ...obj }] })
                        }
                    })
                })

                let tempCap = _.isEmpty(_CBlank) ? [] : _.filter(this.state._temp, o => o.position == _CBlank[0].position)
                let tempVCap = _.isEmpty(_VCBlank) ? [] : _.filter(this.state._temp, o => o.position == _.isEmpty(_VCBlank) ? '' : _VCBlank[0].position)

                let isCap = true
                let isVCap = true

                let finalLineup = _.map(this.state._temp, stm => {
                    Utils.setTransferData(stm, '1')
                    if (!_.isEmpty(_CBlank) && (stm.position == tempCap[0].position && isCap && stm.player_role == 0)) {
                        stm.player_role = 1
                        isCap = false
                    }
                    if (!_.isEmpty(_VCBlank) && stm.position == tempVCap[0].position && isVCap && stm.player_role == 0) {
                        stm.player_role = 2
                        isVCap = false
                    }
                    return stm
                })
                this.setState({
                    LineupList: [..._lineup, ...finalLineup],
                    LineupLoader: false,
                    AutoPickPosing: false,
                })
            }


        }).catch(error => {
            this.props.history.push(Constant.DASHBOARD_PATH)
            console.error(error)
        });
    }
    getMasterRosterList = (list) => {
        this.setState({
            MasterRosterList: list
        })
    }
    closeBox = () => {

    }
    clickAnimation = () => {
        this.setState({ aniclass: true })
        setTimeout(() => {
            this.setState({ aniclass: false })
        }, 5000)
    }
    PlayerCardInit = ()=>{
        this.setState({
            showSSOLogin:true
        })
    }

    toggleSSO = ()=>{
        this.setState({
            showSSOLogin:false
        })
    }

    render() {
        const {
            IS_MYTEAM,
            AppMasterData,
            CurrentLineup,
            SelectedLeague,
            sports_config,
            RosterMasterData,
            lineup_master_id,
            is_single_player,
            isTeamSubmitShow,
            isConfirmTransferShow,
            ALL_POSITION_CLONE,
            SALARY_CAP,
            ALL_POSITION,
            LineupStage,
            contest_id,
            my_performance,
            next_week_start_time,
            joined_week,
            next_week,
            active_week,
            last_week,
            SelectedWeek,
            user_join_count,
            team_info,
            LineupList,
            LineupListClone,
            LineupLoader,

            SelectedPlayer,
            isPlayerCardShow,
            FormationModalShow,
            default_formation,
            default_formation_clone,
            SwapActive,
            AutoPickPosing,
            MasterRosterList,
            aniclass,
            team_update,
            showSSOLogin
        } = this.state
        const DeadlineClockProps = {
            date: Utils.getUtcToLocal(this.props.next_wk),
            gameweek: next_week
        }
        const PitchViewProps = {
            SwapActive,
            ALL_POSITION,
            ALL_POSITION_CLONE,
            joined_week,
            active_week,
            next_week,
            last_week,
            SelectedLeague,
            RosterMasterData,
            lineup_master_id,

            LineupList,
            LineupLoader,
            SelectedWeek: this.state.next_week,
            CurrentLineup,
            team_info,
            LineupStage,
            default_formation,
            MasterRosterList: this.state.RosterArr,
            formation_show: (SelectedLeague.is_allow_bench == 1 && ((user_join_count == 0 && IS_MYTEAM || (next_week == joined_week) && (active_week != last_week)) || user_join_count == 1)),
            getLineupRosterLimit: this.getLineupRosterLimit,
            updateLineupList: this.updateLineupList,
            PlayerListNode: this.triggerPlayerList,
            PlayerCardInit: this.PlayerCardInit,
            toggleDrawer: this.toggleDrawer,
            FormationModalToggle: this.FormationModalToggle,

            SwapInit: this.SwapInit,
            SwapExecute: this.SwapExecute,
            loginbox: true,
            closeBox: this.closeBox,
            homeView: true,
            RemovePlayer:this.RemovePlayer
        }
        const TeamSubmitProps = {
            LineupList,
            RosterMasterData,
            lineup_master_id,
            sports_config,
            default_formation,
            contest_id: contest_id,
            isOpen: isTeamSubmitShow,
            toggle: this.TeamSubmitToggle,
            updateLineupList: this.updateLineupList,
            ALL_TEAM: team_update
        }
        // const isEqualLineup = LineupList.filter(({ player_uid: uid1 }) => !LineupListClone.some(({ player_uid: uid2 }) => uid2 === uid1)).length == 0
        const FormationModalProps = {
            isOpen: FormationModalShow,
            toggle: this.FormationModalToggle,
            RosterMasterData: RosterMasterData,
            default_formation: default_formation,
            FormationChangeHandle: this.FormationChangeHandle
        }
        // console.log(TeamSubmitProps, 'PlayerListPropsPlayerListProps')

        return (
            <>
                <div>
                    <Row className='gutter-fix row-fix'>
                        <Col lg={8} md={8}>
                            <div className='left-sect-header'>
                                <span className='header-lst-txt'><Trans>Create Team</Trans> <span className='info-ic'>
                                    <InfoPopover>
                                        <StaticPage {...{ page_id: '2' }} />
                                    </InfoPopover></span></span>
                                <div>
                                    {this.props.next_wk && <DeadlineClock {...DeadlineClockProps} />}
                                </div>
                            </div>
                            <div className="pitch-header-bottom hfx">
                                {
                                    (SALARY_CAP != 0) &&
                                    <div className="ph-info-block">
                                        <div className="ph-label"><Trans>Available Budget</Trans></div>
                                        <div className="ph-value">{AppMasterData.CURRENCY_CODE} {Utils.AvailableSalary(SALARY_CAP, LineupList)} {REACT_APP_SALARY_SUBFFIX}</div>
                                    </div>
                                }
                                <div className="ph-info-block">
                                    <div className="ph-label"><Trans>Player(s) Selected</Trans></div>
                                    <div className="ph-value">{Utils.SelectPlayerCount(LineupList)}/{this.getLineupRosterLimit(SelectedWeek)}</div>
                                </div>
                                <div className='pitch-control'>
                                    {
                                        (!IS_MYTEAM) &&
                                        <div className={`formation-trigger ${Utils.getTransferData().out.length != 0 ? 'is_trasfer' : ''} ${SwapActive ? 'disabled' : ''}`} onClick={() => this.FormationModalToggle()}>
                                            <div className='formation-data'>
                                                {<img src={default_formation === '4-4-2' ?
                                                    Images[442] : default_formation === '3-5-2' ?
                                                        Images[352] : default_formation === '3-4-3' ?
                                                            Images[343] : default_formation === '4-3-3' ?
                                                                Images[433] : default_formation === '4-5-1' ?
                                                                    Images[451] : default_formation === '5-3-2' ?
                                                                        Images[532] : Images[541]} alt='' />}
                                                <span>{default_formation}</span>
                                            </div>

                                            {
                                                Utils.getTransferData().out.length == 0 &&
                                                <i className="icon-down" />
                                            }

                                        </div>
                                    }
                                    {
                                        (!_.isNull(user_join_count) && IS_MYTEAM) &&
                                        <>
                                            {
                                                (!lineup_master_id && (user_join_count == 0) || !_.isUndefined(CurrentLineup.team_info) && (CurrentLineup.week_info.next_week == CurrentLineup.team_info.joined_week)) &&
                                                <button className='ctrl-btn' onClick={() => this.ResetLineup()}>
                                                    <i className="icon-refresh" />
                                                    <Trans>Reset</Trans>
                                                </button>
                                            }
                                        </>
                                    }
                                    {

                                        <button className='ctrl-btn' onClick={() => this.ResetLineup()}>
                                            <i className="icon-refresh" />
                                            <Trans>Reset</Trans>
                                        </button>
                                    }



                                    {
                                        !is_single_player &&
                                        <button className={aniclass ? 'ctrl-btn blue-box-autopick box-effect' : 'ctrl-btn blue-box-autopick'} onClick={() => this.handleAutoPick()}>
                                            <i className="icon-auto-flash" />
                                            <Trans>Auto Pick</Trans>
                                        </button>
                                    }

                                </div>
                            </div>


                            {/* <GuestPitch getInstance={this.setNodeRef.bind(this, 'GuestPitch')} {...PitchViewProps} /> */}
                            <div className='pitch-with-submit' onClick={() => this.clickAnimation()}>
                                <PitchView getInstance={this.setNodeRef.bind(this, 'PitchView')} {...PitchViewProps} />

                                <div className="home-save-btn">
                                    {/* <div className="text"><Trans>Pick your starting lineup</Trans></div> */}
                                    <Button
                                        disabled={
                                            !this.fullLineup() ||
                                            (SALARY_CAP != 0 ? Utils.AvailableSalary(SALARY_CAP, LineupList) < 0 : false) ||
                                            Utils.SelectPlayerCount(LineupList) !== LineupList.length
                                        }
                                        onClick={() => this.LineupSave(false)}
                                    ><Trans>save</Trans></Button>
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className='roster-mobile-hide'>
                            <Banner type='25' />
                        </Col>
                    </Row>

                    <>
                        {
                            isTeamSubmitShow &&
                            <TeamSubmiModal {...TeamSubmitProps} />
                        }
                        {
                            FormationModalShow &&
                            <FormationModal {...FormationModalProps} />
                        }
                        {showSSOLogin && 
                            <SSOLogin isOpen={showSSOLogin} toggleForm={this.toggleSSO}/>
                        }
                    </>
                </div>
            </>
        );
    }
}
const hteam = ReduxHOC(Hometeam)
export default withRouter(hteam);
